// 検索結果一覧画面の表示切替用

/**
 * ステート
 */
const state = {
  displayMode: 'list', // list or thumbnail
  isFirstTransition: true
}

/**
 * ゲッター
 */
const getters = {
  displayMode (state: any) {
    return state.displayMode
  },
  isFirstTransition (state: any) {
    return state.isFirstTransition
  }
}

/**
 * ミューテーション
 */
const mutations = {
  CHANGE_DISPLAY_MODE (state: any, mode: string) {
    state.displayMode = mode
  },
  UPDATE_SEARCH_STATE (state: any, flag: boolean) {
    state.isFirstTransition = flag
  }
}

/**
 * アクション
 */
const actions = {
  selectDisplayMode (context: any, mode: string) {
    context.commit('CHANGE_DISPLAY_MODE', mode)
  },

}

export default {
  state,
  getters,
  mutations,
  actions
}
